import { render } from "./Couriers.vue?vue&type=template&id=41823023&ts=true"
import script from "./Couriers.vue?vue&type=script&lang=ts"
export * from "./Couriers.vue?vue&type=script&lang=ts"

import "./Couriers.vue?vue&type=style&index=0&id=41823023&lang=scss"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__